class XStoreCardCart {
  constructor() {
    this.cart = null;
    this.refreshTimer = null;

    document.addEventListener('click', this.onClick.bind(this));
    document.addEventListener('DOMContentLoaded', () => this.refresh());
    window.addEventListener('pageshow', () => this.refresh());

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event?.cartData?.items) {
          this.cart = event.cartData;
          this.render();
          return;
        }

        this.refreshSoon();
      });
    }
  }

  get cards() {
    return [...document.querySelectorAll('.xstore-card-cart[data-variant-id]')];
  }

  refreshSoon() {
    clearTimeout(this.refreshTimer);
    this.refreshTimer = setTimeout(() => this.refresh(), 120);
  }

  async refresh() {
    if (!this.cards.length) return;

    try {
      const response = await fetch(`${routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      this.cart = await response.json();
      this.render();
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    if (!this.cart?.items) return;

    const itemsByVariant = new Map();
    this.cart.items.forEach((item) => {
      const variantId = String(item.variant_id);
      const current = itemsByVariant.get(variantId) || { quantity: 0, key: item.key };
      current.quantity += item.quantity;
      current.key = item.key;
      itemsByVariant.set(variantId, current);
    });

    this.cards.forEach((card) => {
      const item = itemsByVariant.get(String(card.dataset.variantId));
      this.setCardQuantity(card, item?.quantity || 0, item?.key || '');
    });
  }

  setCardQuantity(card, quantity, lineKey) {
    card.dataset.cartQuantity = quantity;
    card.dataset.lineKey = lineKey;

    const addButton = card.querySelector('[data-xstore-add-button]');
    const controls = card.querySelector('[data-xstore-cart-controls]');
    const quantityEl = card.querySelector('[data-xstore-cart-quantity]');

    if (quantityEl) quantityEl.textContent = quantity;
    if (addButton) addButton.hidden = quantity > 0;
    if (controls) controls.classList.toggle('xstore-is-hidden', quantity <= 0);
  }

  async onClick(event) {
    const button = event.target.closest('[data-xstore-cart-action]');
    if (!button) return;

    const card = button.closest('.xstore-card-cart[data-variant-id]');
    if (!card || card.dataset.loading === 'true') return;

    event.preventDefault();

    const currentQuantity = Number(card.dataset.cartQuantity || 0);
    const action = button.dataset.xstoreCartAction;
    const nextQuantity = action === 'increase' ? currentQuantity + 1 : 0;

    await this.changeQuantity(card, nextQuantity);
  }

  async changeQuantity(card, quantity) {
    const controls = card.querySelector('[data-xstore-cart-controls]');
    const buttons = controls ? [...controls.querySelectorAll('button')] : [];
    const id = card.dataset.lineKey || card.dataset.variantId;

    card.dataset.loading = 'true';
    buttons.forEach((button) => {
      button.disabled = true;
    });

    const body = JSON.stringify({
      id,
      quantity,
      sections: ['cart-drawer', 'cart-icon-bubble'],
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(routes.cart_change_url, {
        ...fetchConfig(),
        body,
      });
      const state = await response.json();

      this.cart = state;
      this.render();
      this.renderSections(state);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'xstore-card-cart',
          cartData: state,
          variantId: card.dataset.variantId,
        });
      }
    } catch (error) {
      console.error(error);
      this.refreshSoon();
    } finally {
      card.dataset.loading = 'false';
      buttons.forEach((button) => {
        button.disabled = false;
      });
    }
  }

  renderSections(state) {
    if (!state?.sections) return;

    if (state.sections['cart-drawer']) {
      const html = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
      const source = html.querySelector('#CartDrawer');
      const target = document.querySelector('#CartDrawer');
      if (source && target) target.innerHTML = source.innerHTML;
    }

    if (state.sections['cart-icon-bubble']) {
      const html = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html');
      const source = html.querySelector('.shopify-section');
      const target = document.getElementById('cart-icon-bubble');
      if (source && target) target.innerHTML = source.innerHTML;
    }
  }
}

window.xStoreCardCart = window.xStoreCardCart || new XStoreCardCart();
